import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';
import { createEnquirySchema } from '@/lib/forms/schemas/enquirySchema';

export const boneScanEnquirySchema = createEnquirySchema({
  includePreferredContact: false,
  useUkPhoneRegex: true,
});

export type BoneScanEnquiryValues = z.infer<typeof boneScanEnquirySchema>;

export const boneScanEnquiryDefaultValues: BoneScanEnquiryValues = {
  fullName: '',
  phone: '',
  email: '',
  preferredContact: undefined,
  message: '',
};

export const boneScanEnquiryFields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'Enter your full name',
    required: true,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone Number',
    placeholder: '+44 (0) 123 456 7890',
    required: true,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email Address',
    placeholder: 'Enter your email address',
    required: true,
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message',
    placeholder: 'Enter your message',
    required: true,
    maxLength: 2000,
    fullWidth: true,
    rows: 5,
  },
];
